<template>
  <div class="foot">
    <div class="w content flex">
      <div class="con_l flex">
        <div>
          <div class="tit">网站介绍</div>
          <div class="con">{{ findBottomBar.introduction }}</div>
        </div>
        <div>
          <div class="tit">联系方式</div>
          <div class="con">
            <div v-for="(item, idx) in findBottomBar.contact" :key="idx">
              {{ item.type }}：{{ item.content }}
            </div>
          </div>
        </div>
      </div>
      <div class="con_r flex">
        <img :src="imgPrefix + findBottomBar.pic" alt="" />
        <!-- <div>
          <div class="tit">官方微博</div>
          <img src="../assets/index/weibo-qrcode.png" alt="" />
        </div>
        <div>
          <div class="tit">官方微信</div>
          <img src="../assets/index/weixin-qrcode.png" alt="" />
        </div>
        <div>
          <div class="tit">移动校园</div>
          <img src="../assets/index/qrcode.png" alt="" />
        </div> -->
      </div>
    </div>
    <div class="w footer">{{ findBottomBar.endInfo }}</div>
  </div>
</template>

<script>
import imgPrefix from "../../utils/imgPrefix";
import {findBottomBarApi} from '../api/index'
export default {
  data() {
    return {
      findBottomBar: {
        introduction: "",
        contact: [],
        pic: "",
        endInfo: "",
      },
      imgPrefix,
    };
  },
  created() {
    // 获取底部信息
    findBottomBarApi()
      .then((res) => {
        sessionStorage.setItem("findBottomBar", JSON.stringify(res));
        this.findBottomBar = res;
      })
      .catch((err) => {
        this.$message.error(err.message);
        sessionStorage.setItem("findBottomBar", JSON.stringify({}));
      });
    // this.findBottomBar = JSON.parse(sessionStorage.getItem("findBottomBar"));
  },
};
</script>

<style lang="less" scoped>
.foot {
  /* height: 302px; */
  background: #f7f8fb;
  padding: 56px 0 34px 0;
  margin-top: 120px;
  .content {
    justify-content: space-between;
    .tit {
      font-size: 16px;
      color: #1f2c4b;
      padding-bottom: 12px;
    }
    .con_l {
      // width: 60%;
      // justify-content: space-between;
      // align-items: normal;
      div {
        flex: 1;
        width: 100%;
        text-align: left;
      }
      .con {
        font-size: 14px;
        color: #7a8ba4;
        line-height: 20px;
      }
    }
    .con_l div:first-child {
      margin-right: 4%;
    }
    .con_r {
      // width: 35%;
      // justify-content: space-between;
      // align-items: normal;
      img{
        max-width: 300px;
      }
    }
  }
  .footer {
    font-size: 14px;
    /* color: #374567; */
    padding-top: 64px;
    text-align: left;
  }
}
</style>
